import { useEffect } from "react";
import { Stack } from "@chakra-ui/react";

import { RoutesMap } from "../../routes.tsx";
import { SessionStorageKeys } from "../../constants";
import { CardList } from "../../components/features/CardsPage";
import { PageHeader } from "../../components/shared/PageHeader";
import { PageContentLayout } from "../../components/shared/PageContentLayout";

export function CardsPage() {
  useEffect(() => {
    sessionStorage.removeItem(SessionStorageKeys.addPaymentMethodProcessed);
  }, []);

  return (
    <Stack spacing={0} minH="100svh">
      <PageHeader title="Способы оплаты" link={RoutesMap.paymentsSchedule} />

      <PageContentLayout>
        <CardList />
      </PageContentLayout>
    </Stack>
  );
}
